import shortNumber from "short-number";

import { numberWithSpaces } from "root/js/utils";

const tickFormatter = (n, postfix = "") => numberWithSpaces(n > 999 ? shortNumber(n) : n) + postfix;

export { tickFormatter };
